var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"border":"0","width":"100%","height":"100vh","margin-top":"-86px"},attrs:{"src":"https://wholelifegoals.com/about-wlg/"}},[_vm._v("Your browser doesn't support iFrames.")])
}
var staticRenderFns = []

export { render, staticRenderFns }